export const BASE_CREDIT_POOL_ADDRESS =
  "0x48A9892c4F4F86F47e324B1512238b0aA1BB22De";
export const BASE_CREDIT_POOL_ABI = [
  {
    inputs: [],
    name: "creditExpiredDueToFirstDrawdownTooLate",
    type: "error",
  },
  {
    inputs: [],
    name: "creditExpiredDueToMaturity",
    type: "error",
  },
  {
    inputs: [],
    name: "creditLineAlreadyExists",
    type: "error",
  },
  {
    inputs: [],
    name: "creditLineExceeded",
    type: "error",
  },
  {
    inputs: [],
    name: "creditLineNotInGoodStandingState",
    type: "error",
  },
  {
    inputs: [],
    name: "creditLineNotInStateForDrawdown",
    type: "error",
  },
  {
    inputs: [],
    name: "creditLineNotInStateForMakingPayment",
    type: "error",
  },
  {
    inputs: [],
    name: "creditLineOutstanding",
    type: "error",
  },
  {
    inputs: [],
    name: "defaultHasAlreadyBeenTriggered",
    type: "error",
  },
  {
    inputs: [],
    name: "defaultTriggeredTooEarly",
    type: "error",
  },
  {
    inputs: [],
    name: "evaluationAgentServiceAccountRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "exceededPoolLiquidityCap",
    type: "error",
  },
  {
    inputs: [],
    name: "greaterThanMaxCreditLine",
    type: "error",
  },
  {
    inputs: [],
    name: "onlyBorrowerOrEACanReduceCreditLine",
    type: "error",
  },
  {
    inputs: [],
    name: "paymentDetectionServiceAccountRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "permissionDeniedNotLender",
    type: "error",
  },
  {
    inputs: [],
    name: "poolIsNotOn",
    type: "error",
  },
  {
    inputs: [],
    name: "poolOperatorRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "protocolIsPaused",
    type: "error",
  },
  {
    inputs: [],
    name: "requestedCreditWithZeroDuration",
    type: "error",
  },
  {
    inputs: [],
    name: "sameValue",
    type: "error",
  },
  {
    inputs: [],
    name: "withdrawTooSoon",
    type: "error",
  },
  {
    inputs: [],
    name: "withdrawnAmountHigherThanBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "zeroAmountProvided",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "lender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
    ],
    name: "AddApprovedLender",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newDueDate",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
    ],
    name: "BillRefreshed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "creditLimit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "intervalInDays",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "remainingPeriods",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "aprInBps",
        type: "uint256",
      },
    ],
    name: "CreditApproved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "creditLimit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "aprInBps",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "payPeriodInDays",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "remainingPeriods",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "CreditInitiated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "oldCreditLimit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newCreditLimit",
        type: "uint256",
      },
    ],
    name: "CreditLineChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum BaseCreditPool.CreditLineClosureReason",
        name: "reasonCode",
        type: "uint8",
      },
    ],
    name: "CreditLineClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "numOfPeriods",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "remainingPeriods",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
    ],
    name: "CreditLineExtended",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "losses",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
    ],
    name: "DefaultTriggered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "borrowAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "netAmountToBorrower",
        type: "uint256",
      },
    ],
    name: "DrawdownMade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "assetAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmount",
        type: "uint256",
      },
    ],
    name: "LiquidityDeposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "assetAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmount",
        type: "uint256",
      },
    ],
    name: "LiquidityWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "lossesDistributed",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "updatedPoolValue",
        type: "uint256",
      },
    ],
    name: "LossesDistributed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalDue",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "unbilledPrincipal",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
    ],
    name: "PaymentMade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newPoolConfig",
        type: "address",
      },
    ],
    name: "PoolConfigChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "underlyingToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "poolToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "humaConfig",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeManager",
        type: "address",
      },
    ],
    name: "PoolCoreDataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "by",
        type: "address",
      },
    ],
    name: "PoolDisabled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "by",
        type: "address",
      },
    ],
    name: "PoolEnabled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "lender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
    ],
    name: "RemoveApprovedLender",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lender",
        type: "address",
      },
    ],
    name: "addApprovedLender",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "creditLimit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "intervalInDays",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "remainingPeriods",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "aprInBps",
        type: "uint256",
      },
    ],
    name: "approveCredit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "newCreditLimit",
        type: "uint256",
      },
    ],
    name: "changeCreditLine",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "creditRecordMapping",
    outputs: [
      {
        components: [
          {
            internalType: "uint96",
            name: "unbilledPrincipal",
            type: "uint96",
          },
          {
            internalType: "uint64",
            name: "dueDate",
            type: "uint64",
          },
          {
            internalType: "int96",
            name: "correction",
            type: "int96",
          },
          {
            internalType: "uint96",
            name: "totalDue",
            type: "uint96",
          },
          {
            internalType: "uint96",
            name: "feesAndInterestDue",
            type: "uint96",
          },
          {
            internalType: "uint16",
            name: "missedPeriods",
            type: "uint16",
          },
          {
            internalType: "uint16",
            name: "remainingPeriods",
            type: "uint16",
          },
          {
            internalType: "enum BaseStructs.CreditState",
            name: "state",
            type: "uint8",
          },
        ],
        internalType: "struct BaseStructs.CreditRecord",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "creditRecordStaticMapping",
    outputs: [
      {
        components: [
          {
            internalType: "uint96",
            name: "creditLimit",
            type: "uint96",
          },
          {
            internalType: "uint16",
            name: "aprInBps",
            type: "uint16",
          },
          {
            internalType: "uint16",
            name: "intervalInDays",
            type: "uint16",
          },
          {
            internalType: "uint96",
            name: "defaultAmount",
            type: "uint96",
          },
        ],
        internalType: "struct BaseStructs.CreditRecordStatic",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "disablePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "borrowAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "drawdown",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "enablePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "numOfPeriods",
        type: "uint256",
      },
    ],
    name: "extendCreditLineDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getCoreData",
    outputs: [
      {
        internalType: "address",
        name: "underlyingToken_",
        type: "address",
      },
      {
        internalType: "address",
        name: "poolToken_",
        type: "address",
      },
      {
        internalType: "address",
        name: "humaConfig_",
        type: "address",
      },
      {
        internalType: "address",
        name: "feeManager_",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "poolConfigAddr",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address",
      },
    ],
    name: "isApproved",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isApprovedLender",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address",
      },
    ],
    name: "isDefaultReady",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address",
      },
    ],
    name: "isLate",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPoolOn",
    outputs: [
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "lastDepositTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "makeInitialDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "makePayment",
    outputs: [
      {
        internalType: "uint256",
        name: "amountPaid",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "paidoff",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "poolConfig",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address",
      },
    ],
    name: "refreshAccount",
    outputs: [
      {
        components: [
          {
            internalType: "uint96",
            name: "unbilledPrincipal",
            type: "uint96",
          },
          {
            internalType: "uint64",
            name: "dueDate",
            type: "uint64",
          },
          {
            internalType: "int96",
            name: "correction",
            type: "int96",
          },
          {
            internalType: "uint96",
            name: "totalDue",
            type: "uint96",
          },
          {
            internalType: "uint96",
            name: "feesAndInterestDue",
            type: "uint96",
          },
          {
            internalType: "uint16",
            name: "missedPeriods",
            type: "uint16",
          },
          {
            internalType: "uint16",
            name: "remainingPeriods",
            type: "uint16",
          },
          {
            internalType: "enum BaseStructs.CreditState",
            name: "state",
            type: "uint8",
          },
        ],
        internalType: "struct BaseStructs.CreditRecord",
        name: "cr",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lender",
        type: "address",
      },
    ],
    name: "removeApprovedLender",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "creditLimit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "intervalInDays",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "numOfPayments",
        type: "uint256",
      },
    ],
    name: "requestCredit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "poolConfigAddr",
        type: "address",
      },
    ],
    name: "setPoolConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalPoolValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address",
      },
    ],
    name: "triggerDefault",
    outputs: [
      {
        internalType: "uint256",
        name: "losses",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateCoreData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];
